import React from "react";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Problem from "@/components/landing/Problem";
import Pillars from "@/components/landing/Pillars";
import SignatureUSP from "@/components/landing/SignatureUSP";
import LabIntelligence from "@/components/landing/LabIntelligence";
import AICoach from "@/components/landing/AICoach";
import DailySummary from "@/components/landing/DailySummary";
import Credibility from "@/components/landing/Credibility";
import Waitlist from "@/components/landing/Waitlist";
import Footer from "@/components/landing/Footer";
import StickyCTA from "@/components/landing/StickyCTA";

export default function Landing() {
  return (
    <div data-testid="landing-root" className="relative bg-ink-900 text-white overflow-x-hidden">
      <Nav />
      <main>
        <Hero />
        <Problem />
        <Pillars />
        <SignatureUSP />
        <LabIntelligence />
        <AICoach />
        <DailySummary />
        <Credibility />
        <Waitlist />
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
}
